import React from 'react'
import PropTypes from 'prop-types'
import { constants, mixpanel } from 'common/helpers'
import cx from 'classnames'

import { WidthContainer } from 'components/_new/layout/widthContainer'
import UpgradeSubscriptionFlow from 'components/UpgradeSubscriptionFlow/UpgradeSubscriptionFlow'

import Section from '../Section/Section'

import s from './UpgradeSection.scss'


const UpgradeSection = ({ className }) => (
  <Section className={cx(s.upgradeSlide, className)}>
    <WidthContainer className={s.content}>
      <UpgradeSubscriptionFlow
        placement="thankyou page"
        onFirstClick={() => mixpanel.track(constants.analyticsEvents.upgradePopup, { placement: 'thank you' })}
        dataTestId={constants.testIds.thankYouPage.upgradePlansSection}
      />
    </WidthContainer>
  </Section>
)

UpgradeSection.propTypes = {
  className: PropTypes.string,
}

export default UpgradeSection
